import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';


const CssTextField = withStyles({
  root: {
    '& .MuiInputLabel-formControl': {
      top:'-2px'
    },
    '& label.Mui-focused': {
      color: '#49573B',

      
    },
    '& .MuiInput-underline:after': {
      borderColor: '#49573B',
      borderRadius: '1'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#49573B',
        borderRadius: '1'
      },
      '&:hover fieldset': {
        borderColor: '#49573B',
        borderRadius: '1',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#49573B',
        borderRadius: '1'
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    
  },
  margin: {
    marginRight: '6px',
    marginBottom: '10px'
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <>
      <CssTextField
        className={classes.margin}
        label={props.label}
        variant={props.variant}
        id={props.id}
        size={props.size}
        name={props.name}
        autoFocus={false}
        multiline={props.multiline}
        rows={props.rows || 3}
        maxRows={props.maxRows || 3}
        inputProps={{
          maxLength: props.maxLength,
          pattern: props.pattern,
        }}
        InputProps= {{ 
          startAdornment: props.startAdornment ? <InputAdornment position="start">{props.startAdornment}</InputAdornment> : '',
          endAdornment: props.endAdornment ? <InputAdornment position="end">{props.endAdornment}</InputAdornment> : '',
        }}
        {...props}
      />
    </>
  );
}